import { Typography } from "@material-ui/core"

const Genre = (props) => {

  return ( <>
    <Typography>
      Yep! Whether you want a heartfelt acoustic ballad, a pop anthem, a country love song, or even something a little more offbeat (ska proposal song, anyone?), we’ve got you covered. Just let us know the style you’re going for, and our songwriters will bring it to life!
    </Typography>
  </> )
}

export default Genre
